<template>
  <page-header title="Перевозка товаров народного потребления"/>
  <div id="" class="public-container public-container-mobile shipping-types">
    <div class="shipping-types-banner-wrapper">
      <div class="shipping-types-banner mb-30">
        <public-card-info img-url="/images/pages/shipping-type/stapler.png">
          <div class="shipping-types-card-text">
            {{ cardText }}
          </div>
        </public-card-info>
        <public-card-attention
          :text="content.blocks?.order.attentionTitle"
          class="hide-public-card-display-xs mt-30"
        >
          <template #append>
            <div class="mt-20">
              <nuxt-link :to="{ name: 'documents' }" class="text-decoration-underline color-white">
                {{ content.blocks?.order.attentionLink }}
              </nuxt-link>
            </div>
          </template>
        </public-card-attention>
      </div>

      <p>{{ content.blocks?.about.description }}</p>
    </div>

    <div class="shipping-types-block">
      <h2 class="vz-text-align-left">{{ content.blocks?.about.title }}</h2>
      <ul class="public-list public-list-square">
        <li v-for="text in content.blocks?.about.list.split(';')">
          <span>{{ text }}</span>
        </li>
      </ul>
    </div>

    <div class="shipping-types-block">
      <h2 class="vz-text-align-left">{{ content.blocks?.order.title }}</h2>
      <help-services terminal/>
    </div>

    <public-card-attention
      :text="content.blocks?.order.attentionTitle"
      class="show-public-card-display-xs mt-40 mb-80"
    >
      <template #append>
        <div class="mt-20">
          <nuxt-link :to="{ name: 'documents' }" class="text-decoration-underline color-white">
            {{ content.blocks?.order.attentionLink }}
          </nuxt-link>
        </div>
      </template>
    </public-card-attention>

    <div class="shipping-types-block mb-90">
      <h2 class="vz-text-align-left">{{ content.blocks?.delivery.title }}</h2>
      <p>{{ content.blocks?.delivery.description }}</p>

      <div class="shipping-types-block public-text-line" v-html="content.blocks?.delivery.attention"/>
    </div>

    <shipping-types-buttons />

    <shipping-types-chain current="consumer-goods" />
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import PublicCardInfo from '~/components/public/public-card-info.vue'
import PublicCardAttention from '~/components/public/public-card-attention.vue'
import ShippingTypesButtons from '~/components/public/shipping-types/shipping-types-buttons.vue'
import ShippingTypesChain from '~/components/public/shipping-types/shipping-types-chain.vue'
import HelpServices from "~/components/public/help/help-services.vue";
import {storeToRefs} from 'pinia';
import {useCityStore} from '~/stores/city';
import {getPageContent, replaceContentText} from '~/api/content';

const {currentCity} = storeToRefs(useCityStore())

const content = await getPageContent('/shippingtypes/consumer-goods')

const cardText = computed(() => {
  return replaceContentText(content.blocks?.about.cardText, {city: currentCity.value})
})
</script>
